import React from "react";

import { useNavigate } from "react-router-dom";
import ListItem from "../../partials/listItem";
import { Col } from "react-bootstrap";
import { Button, Typography } from "@mui/material";
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';

export default function TaxonomyItem(props) {
  const navigate = useNavigate();

  const item = {
    title: props.item.typeLabel,
    targetVid: props.item.targetVid,
  };
  return (
    <>
      <ListItem item={item} owner="client" variant="taxonomy" titleColXs={3}>
        <Col xs={6}></Col>
        <Col xs={3} className="d-flex justify-content-end">
          <Button variant="text" owner="client"
            onClick={() => navigate(`/taxonomies/${item.targetVid}`)}
            endIcon={<ArrowForwardIosOutlinedIcon sx={{height: "16px"}}/>}
          >
            <Typography owner="client" variant="button">
              List terms
            </Typography>
          </Button>
        </Col>
      </ListItem>
    </>
  );
}
